// extracted by mini-css-extract-plugin
export default {"parentTitle":"billingHistory_parentTitle__jfXob","parentLeaseType":"billingHistory_parentLeaseType__TXIEz"};